import { FC } from 'react'

interface CardHeaderProps {
    current: number,
    max: number
}

const CardHeader: FC<CardHeaderProps> = ({ current = 0, max = 0 }) => {
    const percent = max > 0 ? (current / max) * 100 : 0

    return (
        <>
            <div className='word-card__header'>
                <div id='counter'>{current} / {max}</div>
            </div>
            <div className='word-card__progress-bar'>
                <div
                    className='word-card__progress-bar__fill'
                    style={{ width: `${percent}%` }}
                />
            </div>
        </>
    )
}

export default CardHeader
